import { useEffect, useRef } from 'react'

import Experiment from '@mc/experiments-react'
import { track, getPageSource } from '@mc/track-event'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'

import { StaticData } from 'types/libs/staticData'
import useSticky from 'components/Sticky/useSticky'

import { STICKY_FOOTER_MONEY_BACK_I18N_NAMESPACE } from './i18n'

const PEN_5443_STICKY_FOOTER_MONEY_BACK_FLAG_NAME = 'pen-5443_v1'

export const Pen5443StickyFooterMoneyBackWrapper = ({
  control,
}: {
  control: React.ReactNode
}) => (
  <Experiment
    name={PEN_5443_STICKY_FOOTER_MONEY_BACK_FLAG_NAME}
    control={() => control}
    variant_1={Variant1}
  />
)

const Variant1 = () => {
  const { t } = useTranslation(STICKY_FOOTER_MONEY_BACK_I18N_NAMESPACE)
  const { annualPass } = useStaticData<StaticData>()
  const stickyIsActive = useSticky()
  const alreadyTracked = useRef(false)

  useEffect(() => {
    if (!alreadyTracked.current && stickyIsActive) {
      track('Sticky Footer Viewed', {
        page_source: getPageSource(),
      })
      alreadyTracked.current = true
    }
  }, [stickyIsActive])

  return t('pricing', {
    price: annualPass?.monetizedYearPricePerMonth,
  })
}
